import { HIGH_FIT_RANGE, LOW_FIT_RANGE, MIDDLE_FIT_RANGE } from '.'

export const INVISIBLE = '#90a1b9' // slate-400
// https://www.youtube.com/watch?v=06htW8IUc9M
const RED = '#FF8AB0'
const GOLD = '#FF9A3B'
const GREEN = '#29CCC7'

export const getScoreColorV2 = ({ career, value }) => {
  const mandatory_dimensions = career.dimension_matches.filter(
    ({ mandatory_criterion }) => mandatory_criterion === true
  )

  if (!mandatory_dimensions.length && value > 50) return GREEN
  if (!mandatory_dimensions.length && value <= 50) return RED

  const hasLowFitMandatory = mandatory_dimensions.some(
    ({ dimension_match }) => dimension_match === 0
  )

  const hasMediumFitMandatory = mandatory_dimensions.some(
    ({ dimension_match }) => dimension_match === 0.5
  )

  const hasOnlyHighFitMandatory =
    mandatory_dimensions.filter(({ dimension_match }) => dimension_match === 1)
      .length === mandatory_dimensions.length

  // be aware of the order!

  if (hasLowFitMandatory) return RED
  if (hasMediumFitMandatory) return GOLD
  if (hasOnlyHighFitMandatory) return GREEN

  throw new Error('getScoreColorV2 / somthing went wrong')
}

export const getScoreColorV1 = (value) => {
  if (HIGH_FIT_RANGE(value)) return GREEN
  else if (MIDDLE_FIT_RANGE(value)) return GOLD
  else if (LOW_FIT_RANGE(value)) return RED
  else return INVISIBLE
}
